var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.607a1.745 1.745 0 0 1-.85-.222l-3.37-1.872a10.757 10.757 0 0 1-5.53-9.397V5.92a1.747 1.747 0 0 1 1.568-1.738 17.303 17.303 0 0 0 3.932-.889 17.328 17.328 0 0 0 3.336-1.598 1.751 1.751 0 0 1 1.828 0 17.355 17.355 0 0 0 3.336 1.598 17.303 17.303 0 0 0 3.932.889A1.747 1.747 0 0 1 21.75 5.92v5.196a10.757 10.757 0 0 1-5.53 9.397l-3.37 1.873a1.743 1.743 0 0 1-.85.221zm0-19.67a.239.239 0 0 0-.125.034A18.863 18.863 0 0 1 8.25 4.708a18.77 18.77 0 0 1-4.273.966.248.248 0 0 0-.227.247v5.196a9.255 9.255 0 0 0 4.758 8.086l3.37 1.872a.247.247 0 0 0 .242 0l3.372-1.872a9.255 9.255 0 0 0 4.758-8.086V5.92a.248.248 0 0 0-.227-.247 18.77 18.77 0 0 1-4.273-.966 18.863 18.863 0 0 1-3.625-1.735.235.235 0 0 0-.125-.035z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.25a.746.746 0 0 1-.498-.19l-2.25-2a.75.75 0 0 1 .996-1.12l1.704 1.514 3.251-3.467a.75.75 0 1 1 1.094 1.026l-3.75 4a.747.747 0 0 1-.547.237z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.b88be2c5cbc2636b35b052debb8f63dd.svg";
export { ForwardRef as ReactComponent };